<template>
	<div class="add_admin_wrap">
     <el-button type="primary" size="small" @click="pop_show = true" class="pull-right">新增管理员</el-button>
     <el-dialog title="新增管理员" :visible.sync="pop_show" append-to-body width="95%">
        <el-form :model="adminForm" :inline="true" status-icon :rules="rulesAdminForm" ref="adminForm" label-width="70px">
          <el-form-item label="账号：" prop="username">
            <el-input type="text" v-model="adminForm.username" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="password">
            <el-input type="text" v-model="adminForm.password" autocomplete="off" size="small"></el-input>
          </el-form-item><br>
          <el-form-item label="用户名：" prop="name1">
            <el-input type="text" v-model="adminForm.name1" autocomplete="off" size="small"></el-input>
          </el-form-item>
          <el-form-item label="角色：" prop="group_id">
            <!-- <el-input type="text" v-model="adminForm.group_id" autocomplete="off" size="small"></el-input> -->
            <template>
                <el-select size="small" v-model="adminForm.group_id" placeholder="请选择状态">
                  <el-option
                    v-for="item in options"
                    :key="item.group_id"
                    :label="item.name"
                    :value="item.group_id">
                  </el-option>
                </el-select>
              </template>
          </el-form-item><br>
          <!-- <el-form-item label="用户组：">
            <el-transfer v-model="adminForm.listval" :data="adminForm.list" size="mini"></el-transfer>
          </el-form-item>
          <el-form-item label="权限：">
            <el-transfer v-model="adminForm.listval2" :data="adminForm.list2" size="mini"></el-transfer>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="resetForm('adminForm')">重置</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
	</div>
</template>

<script>
import cons from '@/components/constant';

export default {
  name: 'AddAdmin',
  props:['options'],
  data () {
    var validateUserName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('账号不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('账号是5到20位数字、字母或下划线'));
          }
        }
    };
    var validatePassWord = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('密码不能为空!'));
        } else {
          var rePass = /^[\w!@#$%^&*]{8,20}$/;
          if(rePass.test(value))
          {
            callback()
          }else{
             callback(new Error('密码是8到20位数字、字母或下划线以及特殊!@#$%^&*符号'));
          }
        }
    };
    var validateMobile = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('用户名不能为空!'));
        } else {
          var reUser = /^\w{5,20}$/;
          if(reUser.test(value))
          {
            callback()
          }else{
             callback(new Error('用户名是5到20位数字、字母或下划线'));
          }
        }
    };
    return {
      pop_show:false,
      adminForm:{
        username:'',
        password:'',
        name1:'',
        group_id:'',
        listval:[],
        listval2:[]
      },
      rulesAdminForm:{
        username: [
            { validator: validateUserName, trigger: 'blur' }
        ],
        password: [
            { validator: validatePassWord, trigger: 'blur' }
        ],
        name1: [
            { validator: validateMobile, trigger: 'blur' }
        ]
      }
    }
  },
  methods:{
    submitForm(){
      if(this.adminForm.username==='' || this.adminForm.password==='' || this.adminForm.name1==='' || this.adminForm.group_id===''){
        this.$message({
            type:'error',
            message:'请填写全部信息'
        });
        return
      }
      let token = localStorage.token;

       this.axios.post(cons.apis + '/v1_0/administrators', {
              "account":this.adminForm.username,
              "password":this.adminForm.password,
              "name":this.adminForm.name1,
              "group_id":this.adminForm.group_id,
            },{
            headers: {
              'Authorization': 'Bearer ' + token
            },
            responseType: 'json'
        })
        .then(dat=>{
            if(dat.status==201){
              this.$message({
                type: 'success',
                message: '添加管理员成功!'
              });
              this.pop_show = false;
              this.adminForm.name = '';
              this.adminForm.listval = [];
              this.adminForm.listval2 = [];
              this.resetForm('adminForm')
              this.$emit('fnResetTable');
            }
        }).catch(err=>{
           if(err.response.status==400){
               this.$message({
                  type:'info',
                  message:err.response.data.name[0]
              });
           }
        });
    },
    resetForm(formName){
      this.$refs[formName].resetFields();
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/widget/AddAdmin.vue